module.exports = __webpack_public_path__ + "static/img/tu3@1x.3436c88.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/tu3@1x.png
// module id = u7kZ
// module chunks = 2